import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFileText"><Path d="M13 2.5H4.5V21.5H19.5V9L13 2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 13.5H12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 17.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13 3V9H19" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFileText;
